import React from 'react'
import { useTheme } from '@mui/material'
import { BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Rectangle } from 'recharts'

import { useTranslation } from 'react-i18next'

const CustomCursor = props => {
  const theme = useTheme()
  const { x, y, width, height } = props;
  return <Rectangle fill={theme.palette.grey[100]} stroke={theme.palette.grey[100]} x={x} y={y} width={width} height={height} />;
};

const Chart = ({
  data,
  tooltip,
  customYTickFormatter = (tick) => tick,
  children,
}) => {
  const { t } = useTranslation()
  const customTickFormatter = tick => {
    return t(`ui_elements.months.${tick}`)
  }
  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <BarChart
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5
          }}>
          <XAxis
            tickFormatter={customTickFormatter}
            dataKey="month"
            style={{
              fontSize: '0.75rem',
              fontWeight: 400
            }}
          />
          <YAxis
            tickFormatter={customYTickFormatter}
            style={{
              fontSize: '0.75rem',
              fontWeight: 400
            }}
          />
          <Tooltip
            offset={10}
            cursor={<CustomCursor />}
            wrapperStyle={{ outline: 'none', top: 0, zIndex: 10000 }}
            content={tooltip}
          />
          { children }
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default Chart